import { replica } from '@/shared/sync/replica';

/** Approve (the agent gets a token that acts as you) or deny a pending request. */
export async function decideAccessRequest(id: string, decision: 'approve' | 'deny'): Promise<void> {
  await replica.http.json<void>(`/access/requests/${encodeURIComponent(id)}/${decision}`, { method: 'POST' });
}
